import { Container, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import * as api from "../../api";
import { workOrderRepairObject } from "../../ducks/redux/actions/getAddress";

import {
  userChosenAdditionalDescription,
  userChosenAdditionalDescriptionCOUNT,
  userChosenVulnerabilityAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenCovidQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVandalismQuestion,
  isEditState,
  resumeDraftRepair,
  backToRepairAsset,
  workOrderData,
  userChosenSaveExit,
  userChosenNotifyAll,
  hasExistingDmRecord,
  saveDMQuestionnaireEnabled,
  dmcCheckSavedAnswer
} from "../../ducks/redux/actions/userChoices";
import { RouteComponentProps } from "react-router-dom";
import Button from "../../Button/Button";
import Loader from "react-loader-spinner";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import "./style.css";
import RepairJourney from "../RepairJourney";
import { getDMCSorCodeReference, isNullOrUndefined } from "../../utils/formatting";
import { PermissionsList } from "../../models/Permissions";
import { RepairPriorityCode } from "../../models/Repair/CreateRepair";
import { saveDuplicateDMCAnswers } from '../../ducks/redux/actions/FinancialReferral';
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { Helper } from "../../utils/Helper/HelperUtil";


interface RepairAdditionalDetailsProps extends RouteComponentProps<any> { }

const isHazardRepairExcluded = (asset: any, reason: any, isRecall: boolean): boolean =>
  Boolean(isRecall || asset?.statuses?.isInDefects || asset?.maintenanceResponsibilities?.some((responsibility: any) =>
    (responsibility.type === "MAINTSRESP" || responsibility.type === reason?.element) && responsibility.value === "EMAFULL"));

const RepairAdditionalDetails: React.FC<RepairAdditionalDetailsProps> = (
  props
) => {
  const { t } = useTranslation();
  const NEC_TOTAL_LIMIT = 240;
  const highLevelDescription = useSelector((state: any) => state?.userChoicesReducer?.userChosenHighLevelDescription ?? "");
  const calculatedLimit = NEC_TOTAL_LIMIT - (highLevelDescription?.length ?? 0);
  const maxLengthLimit = calculatedLimit > 0 ? calculatedLimit.toString() : "0";
  const saveExitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const minLengthLimit = "0";
  const format = /^(?!.*--)[^><&*!%]*$/;
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [characterCount, setCharacterCount] = useState(maxLengthLimit);
  const [count, setCount] = useState(0);
  const [value, setValue] = useState("");
  const [isError, setError] = useState("none");
  const [isLoading, setIsLoading] = useState(false);
  const [closeAfterSaving, setCloseAfterSaving] = useState(false);

  const [showSpecialCharacterWarning, setShowSpecialCharacterWarning] = useState("");

  // active pop case flag
    const activePopHazardCaseFlag = useSelector(
    (state: any) => state?.hazard?.activePopHazardCaseFlag
  );


  const userChosenAdditionalDescriptionBackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenAdditionalDescription
  );
  const isDmcEnabled = useSelector((state: any) => state?.userChoicesReducer?.isDMQuestionnaireEnabled);
  const EditState = useSelector(
    (state: any) => state?.userChoicesReducer?.isEditState
  );
  const IsRecall = useSelector(
    (state: any) => state?.userChoicesReducer?.IsRecall
  );

  const workOrderObject = useSelector(
    (state: any) => state?.addresses?.workOrderRepair
  );

  const userChosenEmergencyQuestionBackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenEmergencyQuestion
  );

 
  const assetDetails = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const assetIdentifier = assetDetails?.id ?? "";
  const uprn = assetDetails?.uprn ?? "";
  const associatedType = assetDetails?.assetType;
  const userChosenDuplicateQuestion = useSelector((state: any) => state?.userChoicesReducer?.userChosenDuplicateQuestion);
  const selectedRepairReason = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject);
  const dmCauseCheckSkipSorCodesValue = useSelector((state: any) => state?.financialReferralReducer?.sordamp);
  const userChosenSOR = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const resumeDraftRepairVal = useSelector((state: any) => state?.userChoicesReducer?.resumeDraftRepair);
  const userResumeDraftDataCache = useSelector((state: any) => state?.userChoicesReducer?.userResumeDraftDataCache);
  const assetByIdDataObject = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const vandalismConfigValue = useSelector((state: any) => state?.userChoicesReducer?.vandalismtoggleValue);
  const isRepairMedia = useSelector((state: any) => state?.userChoicesReducer?.isRepairMediaAllowed);
  const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
  const choosePriorityOfRepairPermission = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workorder_choose_priority_of_repair) >= 0;
  const createEnhancedHubRepairPermissions = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workorder_view_ADHESIVE_prompt_additional_details) >= 0;
  const priorityCodeValue = useSelector((state: any) => state?.dashboardReducer?.formState?.priorityCode);
  const dmSkipQuestionnaireSorCodesValue = useSelector((state: any) => state?.userChoicesReducer?.dmcRepairSorCodeValues);
  const isHHSRSEnabled = useSelector((state: any) => state?.financialReferralReducer?.isHHSRSEnabled)
  const hhsrsOptionFromStore = useSelector((state: any) => state.financialReferralReducer?.saveHHSRSOptionValue);
  const isHHSRSRole = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.update_digital_journey_hhsrs_hazard_repair);
  const hadDMInspectionSuccessfullyCreated = workOrderObject?.associatedWorkOrdersType === "DampAndMould" && !isUndefinedNullOrEmpty(workOrderObject.associatedWorkOrdersJobNumber);
  const isHHSRSRepairEnabledCheck = useSelector((state: any) => state?.userChoicesReducer?.isHHSRSRepairEnabled);
  const savedHazardQuestions = useSelector((state: any) => state.hazard?.hazardQuestions);
  const preAssessmentJourneyQuestions = useSelector((state: any) => state.hazard?.preAssessmentJourneyQuestions);
  const hasAssessmentQuestions = selectedRepairReason?.[0]?.isPreAssessmentRequired === true
    ? preAssessmentJourneyQuestions?.some((question: any) =>
      Helper.isMatchingPreAssessmentCategory(
        question.category,
        `${Helper.PreAssessment.CategoryPrefix}${selectedRepairReason[0].diagnosticId}`
      )
    )
    : savedHazardQuestions?.length > 0;
  const hasActiveProdampWorkOrder = async () => {
    const queryParams: any = {
      propertiesIds: [assetIdentifier],
      searchText: uprn,
      status: "Appointed,Unappointed,In Progress",
      sor: "PRODAMP",
      isDuplicateCheck: false,
      orderBy: "raisedDate desc",
      limit: 1,
      assetType: associatedType
    };
    const res = await api.getWorksOrdersApi(queryParams);
    return Array.isArray(res?.worksOrders) && res.worksOrders?.length > 0 && res?.totalCount !== 0;
  };
  const hasActiveDmcCase = async () => {
    const queryParams: any = {
      assetIdentifiers: [assetIdentifier],
      searchText: "",
      status: "Active",
      orderBy: "createdDate desc",
      limit: 1,
      skip: 0,
      ownerEmailId: "",
      assetType: associatedType,
      caseSubType: "Damp, Mould and Condensation",
      caseSubTypeCategory: "Damp, Mould and Condensation",
    };
    const res = await api.getCaseData(queryParams);
    return Array.isArray(res?.cases) && res.cases?.length > 0 && res?.["total-count"] !== 0;
  };


  useEffect(() => {
    window.scrollTo(0, 0);
    setValue(userChosenAdditionalDescriptionBackButton);
    setCount(userChosenAdditionalDescriptionBackButton?.length ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workOrderObject, getPermissionsData]);

  useEffect(() => {
    if (value !== "") {
      setError("none");
    }
  }, [value]);

  useEffect(() => {
    const highLevelTextLength = highLevelDescription?.length ?? 0;
    const calculated = hhsrsOptionFromStore && isHHSRSEnabled ? NEC_TOTAL_LIMIT - highLevelTextLength - 7 : NEC_TOTAL_LIMIT - highLevelTextLength;
    setCharacterCount(calculated > 0 ? calculated.toString() : "0");
  }, [highLevelDescription]);

  useEffect(() => {
    toggleDMC()
    return () => {
      if (saveExitTimeoutRef.current) {
        clearTimeout(saveExitTimeoutRef.current);
        saveExitTimeoutRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    (async () => {
      const isDMCEnabledToggle = await api.GetAppConfigToggleValue(
        "P360:isDMQuestionnaireEnabled"
      );
      if (isDMCEnabledToggle) {
        let isDMCToggleValue: boolean = isDMCEnabledToggle?.value.toLowerCase() === 'true';
        dispatch(saveDMQuestionnaireEnabled(isDMCToggleValue));
        if (!isDMCToggleValue) {
          dispatch(dmcCheckSavedAnswer("No"));
        }
      }
    })()
  }, [])


  const toggleDMC = async () => {
    try {
      const isDMCEnabledToggle = await api.GetAppConfigToggleValue(
        "P360:isDMQuestionnaireEnabled"
      );
      if (isDMCEnabledToggle) {
        let isDMCToggleValue: boolean = isDMCEnabledToggle?.value.toLowerCase() === 'true';
        dispatch(saveDMQuestionnaireEnabled(isDMCToggleValue));
        if (!isDMCToggleValue) {
          dispatch(dmcCheckSavedAnswer("No"));
        }
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  const onChange = (e: any) => {
    if (EditState === true) {
      dispatch(userChosenNotifyAll(null));
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      dispatch(userChosenVulnerabilityQuestion("No"));
      dispatch(isEditState(false));
      dispatch(userChosenVandalismAdditionalInformation(""));
      dispatch(userChosenVandalismQuestion("No"));
      //dispatch(removeAllDMCData(null));
    }
    const additionDetailsInputRaw = e.target.value,
      additionalDetailsRegexMatch = !isNullOrUndefined(additionDetailsInputRaw) && additionDetailsInputRaw !== "" ? additionDetailsInputRaw.match(/[^><*&!%]+/gm) : null;
    let additionalDetailsInput = !isNullOrUndefined(additionalDetailsRegexMatch) ? additionalDetailsRegexMatch[0] ?? "" : "";


    if (format.test(e.target.value)) {
      setShowSpecialCharacterWarning("");
    } else {
      setShowSpecialCharacterWarning(t("Additional_Details_Input"));
      e.target.value = additionalDetailsInput.replaceAll(/[&*%!<>]/g, '');
    }
    const textValue = e.target.value.trim()
    if (textValue.length > 0) {
      if (e.target.value.length < Number.parseInt(characterCount) + 1) {
        e.target.value.length > Number.parseInt(characterCount)
          ? setCount(Number.parseInt(characterCount))
          : setCount(e.target.value.length);
      } else setCount(Number.parseInt(characterCount));
    }
    else {
      setCount(0)
    }

    setValue(e.target.value.substr(Number.parseInt(minLengthLimit), Number.parseInt(characterCount)));

    dispatch(
      userChosenAdditionalDescription(
        e.target.value.substr(Number.parseInt(minLengthLimit), Number.parseInt(characterCount))
      )
    );
    dispatch(userChosenAdditionalDescriptionCOUNT(e.target.value.length));
  };

  const helpTextValue = (count || 0) + "/" + characterCount;

  const UpdateWorkOrder = async (field: boolean) => {
    try {
      setIsLoading(true);
      workOrderObject.additionalInformation = value;
      workOrderObject.priority = priorityCodeValue;
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters = _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      );

      dispatch(workOrderRepairObject(workOrderObject));
      if (field) {
        props.history.push(`/WorkOrder360View/${workOrderObject.id}`);
      }

    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    } finally {
      setIsLoading(false);
    }
  };



  const backButtonHandler = () => {
    const isEDRepair = workOrderObject?.isEnhancedDiagnosticsRepair;
    const hasDuplicate = !isNullOrUndefined(userChosenDuplicateQuestion);
    const hasEmergencyBack = !isNullOrUndefined(userChosenEmergencyQuestionBackButton);
    const isDampAndMouldEmergency =
      workOrderObject?.priority === RepairPriorityCode.DampAndMouldEmergency;
    const hasSupplementary =
      !!selectedRepairReason?.[0]?.additionalData?.[0]?.description;

    // Business rule: clear additional description if not Recall and no createEnhancedHubRepairPermissions
    if (!IsRecall && !createEnhancedHubRepairPermissions) {
      dispatch(userChosenAdditionalDescription(""));
    }

    // 1) Duplicate journey takes precedence
    if (hasDuplicate) {
      return props.history.push(isHHSRSEnabled && isHHSRSRole && !isEDRepair ? "/hhsrs" : "/DuplicateRepair");
    }

    // 2) Emergency Back + ED journey (AR1 only)
    if (hasEmergencyBack && isEDRepair) {
      if (choosePriorityOfRepairPermission) {
        return props.history.push("/RepairEDEmergency");
      }
      // Non-AR1 in ED: per Phase 1 comment, do nothing (no navigation).
      return;
    }

    // 3) Emergency Back + SD + HHSRS for non-HHSRS role
    if (hasEmergencyBack && !isEDRepair && isHHSRSEnabled && isHHSRSRole) {
      return props.history.push("/hhsrs");
    }

    // 4) Emergency Back + SD + non-AR1
    if (hasEmergencyBack && !isEDRepair && !choosePriorityOfRepairPermission) {
      if (isDampAndMouldEmergency && isHHSRSEnabled && isHHSRSRole) {
        return props.history.push("/hhsrs");
      }
      if (isDampAndMouldEmergency) {
        return props.history.push("/RepairLocation");
      }
      return props.history.push("/RepairEmergency");
    }

    // 5) Generic HHSRS enabled
    if (isHHSRSEnabled && isHHSRSRole && !isEDRepair) {
      return props.history.push("/hhsrs");
    }

    // 6) Supplementary question present
    if (hasSupplementary) {
      return props.history.replace("/SupplementaryQuestion");
    }

    // 7) Default
    return props.history.replace("/RepairLocation");
  };


  const exitButtonHandler = () => {
    dispatch(backToRepairAsset(false))
    props.history.push("/LandingView");
  };

  const saveDraftAndExit = async () => {
    dispatch(userChosenSaveExit(true));
    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderData(worksOrder));
    //Implement Save Draft and Exit functionalities here...
    const countValue = count?.toString() ?? "0";
    if (countValue !== "0") {
      setError("none");
      try {
        await UpdateWorkOrder(true);
      } catch (e) {
        console.error(e);
        props.history.push("/GenericError");
      }
    } else {
      setError("block");
      props.history.push(`/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`);
    }
    setCloseAfterSaving(true);
    dispatch(backToRepairAsset(false));
    saveExitTimeoutRef.current = setTimeout(() => {
      dispatch(userChosenSaveExit(false));
    }, 6000);
  };

  const callPageHandler = async () => {
    try {
      setIsLoading(true);
      setIsButtonDisabled(true);
      if (resumeDraftRepairVal) {
        const { additionalInformation } = userResumeDraftDataCache;
        if (additionalInformation !== value) {
          dispatch(resumeDraftRepair(false));
          dispatch(userChosenVandalismQuestion("No"));
          dispatch(userChosenVandalismAdditionalInformation(""));
          dispatch(userChosenCovidQuestion(""));
          dispatch(userChosenVulnerabilityQuestion("No"));
          dispatch(userChosenVulnerabilityAdditionalInformation(""));
          dispatch(saveDuplicateDMCAnswers(null));
          //removing all dmc answers when user changes the additional information
          //dispatch(removeAllDMCData(null));
        }
      }

      const countValue = count?.toString() || "0";
      if (countValue === "0") {
        setError("block");
        return;
      }
      dispatch(saveDuplicateDMCAnswers(null));
      await UpdateWorkOrder(false);
      setError("none");

      const navigateTo = (path: string) => {
        props.history.push(path);
      };

      const isDMQuestionnaireEnabled = isDmcEnabled && !dmSkipQuestionnaireSorCodesValue?.includes(userChosenSOR) && assetByIdDataObject?.assetType === "Property";
      const skipCausingDMQuestion = getDMCSorCodeReference(dmCauseCheckSkipSorCodesValue, userChosenSOR);

      let existingDmRecord = false;

      if (isDMQuestionnaireEnabled) {
        if (!skipCausingDMQuestion) {
          try {
            const [woExists, caseExists] = await Promise.all([
              hasActiveProdampWorkOrder(),
              hasActiveDmcCase(),
            ]);
            existingDmRecord = woExists || caseExists;
            dispatch(hasExistingDmRecord(existingDmRecord));
          } catch (e) {
            // if the api fails, we want to skip the DM questions to avoid blocking the user
            console.log("Error in skipCausingDMQuestion", e)
            existingDmRecord = true;
            dispatch(hasExistingDmRecord(true));
          }
        }
      }

      if (skipCausingDMQuestion) {
        navigateTo("/DampAndMouldAssesment/1");
      } else if (isDMQuestionnaireEnabled && !existingDmRecord && !hadDMInspectionSuccessfullyCreated) {
        navigateTo("/ConfirmedDampMould");
      } else if (hasAssessmentQuestions && isHHSRSRepairEnabledCheck === true &&
        selectedRepairReason[0]?.isPreAssessmentRequired === true) {
        navigateTo("/HazardPreassessment");
      }
      //should not navigate to hazard assessment if active Pop case duplicate hazard resume 
      else if (hasAssessmentQuestions && isHHSRSRepairEnabledCheck === true && !activePopHazardCaseFlag) {
        navigateTo("/HazardAssessment/1");
      }
      else if (isRepairMedia === "true") {
        navigateTo("/RepairUploadmedia");
      } else if (
        assetByIdDataObject?.statuses.isInDefects === true &&
        vandalismConfigValue === true
      ) {
        navigateTo("/VandalismQuestion");
      } else {
        dispatch(userChosenVandalismQuestion(""));
        navigateTo("/VulnerabilityQuestion");
      }
    } catch (e) {
      console.log("Error in RepairAdditonal Detail", e);
    } finally {
      setIsLoading(false);
      setIsButtonDisabled(false);
    }
  };

  const repairOtherInfoItems = [
    { codeKey: 'repair_other_info_A', textKey: 'repair_other_info_Access' },
    { codeKey: 'repair_other_info_D', textKey: 'repair_other_info_Damage' },
    { codeKey: 'repair_other_info_H', textKey: 'repair_other_info_How_long' },
    { codeKey: 'repair_other_info_E', textKey: 'repair_other_info_Establish_history' },
    { codeKey: 'repair_other_info_S', textKey: 'repair_other_info_Safety_Security' },
    { codeKey: 'repair_other_info_I', textKey: 'repair_other_info_Information_Make_Model' },
    { codeKey: 'repair_other_info_V', textKey: 'repair_other_info_Vulnerabilities' },
    { codeKey: 'repair_other_info_E2', textKey: 'repair_other_info_Escalation' },
  ];

  return (
    <Container id="repAddDet-container" role="main" className="ctn-fht">
      <div id="backmodal-div1" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0" >
        <div className="back-and-journey">
          <p id="backmodal-p" className="text-teal text-xl mt-4 mb-4 md:mb-12">
            <button className="back-btn" onClick={backButtonHandler}>
              <i className="fas fa-angle-left mr-2"></i>
              {t("back")}
            </button>
          </p>
          <div className=""></div>
          {<RepairJourney />}
        </div>
      </div>
      <div id="repAddDet-main-div"
        className="question ml-sm-5 pl-sm-5 repair-text container"
      >
        <div id="repAddDet-div1" className="py-2 h5 mar-repadd">
          <h2 id="repAddDet-h1" className="text-purple-100 text-2xl mb-2 rep-mar global-txt"> {t("Additional_Details_CPR024")}</h2>
        </div>

        {!createEnhancedHubRepairPermissions && <div id="repAddDet-div2" className="mt-1">
          <ul id="repAddDet-ul" className="text-black fw-light">
            <li id="repAddDet-li1" className="py-2 global-txt">
              {t("Additional_Details_CPR025_1")}
            </li>
            <li id="repAddDet-li2" className="py-2 global-txt">
              {t("Additional_Details_CPR025_2")}
            </li>
            <li id="repAddDet-li3" className="py-2 global-txt">
              {t("Additional_Details_CPR025_3")}
            </li>
          </ul>
        </div>}
        <span className="text-gray-700 text-black global-txt fw-light">{t("Additional_Details_CPR026")}</span>
        {createEnhancedHubRepairPermissions && <Typography className="adhesive-container">
          {t('repair_other_info_label_description')}{' '}
          <span className="bold-text">{t('repair_other_info_label_description_supporting_text')}</span>

          <ul style={{ margin: 0, paddingLeft: 0 }}>
            {repairOtherInfoItems.map(({ codeKey, textKey }) => (
              <li key={codeKey}>
                <span className="bold-text mr-k">{t(codeKey)}</span>
                <span className="mr-2">-</span>
                {t(textKey)}
              </li>
            ))}
          </ul>
        </Typography>}
        <div
          id="repAddDet-div3"
          className="global-txt mt-1"
          data-testid="repairdetails"

        >
          <label className="w-full global-txt">
            <TextField aria-invalid="true"
              margin="normal"
              className="textarea-additional-details global-txt pb-4 border-grey"
              helperText={helpTextValue}
              data-testid="Repair_Additional_Details_Placeholder"
              onChange={(e) => onChange(e)}
              id="outlined-textarea"
              value={value}
              placeholder={t("Additional_Details_CPR026a")}
              InputProps={{
                inputComponent: 'textarea', style: { padding: 0, height: 'auto' }
              }}
              size="medium"
              error={count >= Number.parseInt(maxLengthLimit)} />
          </label>
        </div>

        <div className="error mb-8" style={{ display: isError }} id="repAddDet-div4" role="alert">
          <div className="w-full px-2 py-2 bg-yellow flex items-center">
            <div className="px-4 pr-8">
              <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
            </div>
            <div className="flex items-center text-black">
              <p className="w-full text-left my-2 font-AvantGardeGothic-Md">{t("Additional_Details_CPR027")}</p>
            </div>
          </div>
        </div>
        {showSpecialCharacterWarning && (
          <div
            data-testid="alert-warning"
            className="error mb-8 sm:mx-1"
            role="alert"
            placeholder="alert-message"
          >
            <div className="w-full px-2 py-2 bg-yellow flex items-center">
              <div className="px-4 pr-8">
                <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
              </div>
              <div className="flex items-center">
                <p
                  data-testid="locatioAlert_0"
                  className="w-full text-left my-2 font-AvantGardeGothic-Md"
                >
                  {" "}
                  {t(showSpecialCharacterWarning)}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        id="repAddDet-div5"
        className="flex justify-between items-center pb-4 md:pb-8 container"
      >
        <ExitModalAndSave
          id="repAddDet-exitmodal"
          exit={exitButtonHandler}
          saveDraftAndExit={saveDraftAndExit}
          closeAfterSaving={closeAfterSaving}
        />
        <Button
          id="btn_additionaldetails"
          disabled={isButtonDisabled}
          onClick={callPageHandler}
          className="button-class"
        >
          {t("continue")}{" "}
          <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
        </Button>
      </div>
      <span>
        {isLoading ? (
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={70}
            width={50}
            timeout={5000}
          />
        ) : (
          <>
            <div></div>
          </>
        )}
      </span>
    </Container>
  );
};
export default RepairAdditionalDetails;
